import React from 'react';
import { TagModal } from '../../components/modals/TagModal';
import type { Batch } from '../../hooks/useProjectBatches';

interface Props {
  projectId: string;
  batch: Batch;
  onClose: () => void;
}

export function EditBatchModal({ projectId, batch, onClose }: Props) {
  const tag = {
    id: batch.id,
    projectId,
    categoryId: '',
    name: batch.name,
    color: '#d214e3',
    isNameEditable: false,
    numResources: null,
    assignees: null,
    parentId: null,
    status: batch.status,
    users: batch.users,
    roles: batch.roles,
  };

  return <TagModal projectId={projectId} tag={tag} defaultColor="#d214e3" onClose={onClose} />;
}
